import Styles from './styles.module.css';
import React from 'react';

type SchoolItemProps = {
  itemName: string;
  value: number;
  barValue: number;
};

const SchoolItem: React.FC<SchoolItemProps> = ({ itemName, value, barValue }) => {

  return (
    <>
    <div className={Styles.items_table}>
      <h4 className={Styles.item_title_name}>{itemName}</h4>
      <p className={Styles.item_title_unit}>{value}<br />件</p>
      <div className={Styles.item_title_data}>
        <div className={Styles.item_title_data_title}>
          <p style={{ textAlign : 'left' }}>0</p>
          <p style={{ textAlign : 'center' }}>{barValue / 2}</p>
          <p style={{ textAlign : 'right' }}>{barValue}</p>
        </div>
        <div className={Styles.item_graph}>
          <div className={Styles.item_graph_horizon}>
            <div></div>
            <div></div>
            <div></div>
          </div>
          <div className={Styles.item_graph_vertical}></div>
          <div className={Styles.item_graph_data} style={{ width: barValue === 0 ? "0%" : `${(value / barValue) * 100}%` }}></div>
        </div>
      </div>
    </div>
    </>
  );
}

export default SchoolItem;
